import(/* webpackMode: "eager", webpackExports: ["AssetsExplorer"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\components\\AssetsExplorer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\node_modules\\next\\dist\\client\\app-dir\\link.js");
